// A job in the client-documents tree, folded down to the files filed against it: its
// signed contracts, the scans of any invoice it billed, and the clippings of its
// coverage — merged into one list, newest first.
//
// ONE component for both kinds of job, exactly as the client card's JobBlock is. A topic
// inside a retainer and a standalone one-off differ in where they SIT and in nothing
// about what they hold. A topic simply never has invoice scans, because it bills nothing
// — that falls out of the data rather than needing a branch here.
//
// The header carries the status and the count whether the fold is open or shut, so
// closing it hides contents and never facts. The link to the job's own screen is the way
// OUT: this page cannot upload a contract, and the screen that can is one click away.
import { useNavigate } from 'react-router-dom';
import he from '../../i18n/he';
import Collapsible from '../../components/Collapsible';
import StatusBadge from '../../components/StatusBadge';
import Button from '../../components/Button';
import DocumentTable from './DocumentTable';

export default function JobNode({ job, archived, open, onToggle, level = 3 }) {
  const navigate = useNavigate();

  return (
    <Collapsible
      level={level}
      open={open}
      onToggle={onToggle}
      title={job.title}
      badges={
        <>
          <StatusBadge kind="job" value={job.status} />
          <span className="badge gray">{he.clientDocuments.documentCount(job.fileCount)}</span>
        </>
      }
      meta={
        <Button small variant="subtle" onClick={() => navigate(`/jobs/${job.id}`)}>
          {he.clientCard.openJob}
        </Button>
      }
    >
      <DocumentTable files={job.files} archived={archived} />
    </Collapsible>
  );
}
